import React from 'react';
import { connect } from 'react-redux';

const OrderRowFirstCol = props => {
  const { order } = props;
  return (
    <div>
      <div>
        {order.date.slice(0,10)}
      </div>
      <div>
        {order.id.toLowerCase().replace('-', '')}
      </div>
      <div>
        {order.type === 'a' ? 'Аксессуары' : 'Техника'}
      </div>
      <div>
        {order.userId}
      </div>
    </div>
  );
}

export default connect()(OrderRowFirstCol);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/order-props.js